module.exports = __webpack_public_path__ + "img/809-07210b.png";